export default () => ({
    root: {
        height: 400,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '8px',
    },
    toolbarSearch: {
        width: '50%',
    },
    showMoreContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '16px 0',
    },
});
